import {createDivIn, createHeaderIn, createImgIn, createParagraphIn} from '../ui_utils/DomUtils'
import {TranslationObject} from '@colonist/i18n'
import {LobbyImage} from '@colonist/types'
import {ViewPopup} from './ViewPopup'

interface RuleInformationBodyElement {
    header: TranslationObject
    text: TranslationObject
    image: LobbyImage
    visible: boolean
}

export class ViewPopupRulesInformation extends ViewPopup {
    private readonly isTournamentRoom: boolean

    constructor(isTournamentRoom: boolean = false) {
        super({key: 'strings:roomPage.rules.title'},
            {key: 'strings:colonistCommon.utils.emptyString'},
            () => undefined,
            () => undefined,
            true,
            {showXonHeader: true, showXButton: false, showCheckButton: false})

        this.isTournamentRoom = isTournamentRoom

        const rulesInformationBodyElements = this.getRulesInformationBodyElements()
        this.initializeRulesInformationBody(rulesInformationBodyElements)

        this.removeFooter()
        this.show()
    }

    private getRulesInformationBodyElements(): RuleInformationBodyElement[] {
        const rulesInformationBodyElements: RuleInformationBodyElement[] = [
            {
                header: {key: 'strings:roomPage.rules.ruleInformation.privateGame.header'},
                text: {key: 'strings:roomPage.rules.ruleInformation.privateGame.body'},
                image: LobbyImage.PrivateGame,
                visible: !this.isTournamentRoom,
            },
            {
                header: {key: 'strings:roomPage.rules.ruleInformation.hideBankCards.header'},
                text: {key: 'strings:roomPage.rules.ruleInformation.hideBankCards.body'},
                image: LobbyImage.HideBankCards,
                visible: true,
            },
            {
                header: {key: 'strings:roomPage.rules.ruleInformation.friendlyRobber.header'},
                text: {key: 'strings:roomPage.rules.ruleInformation.friendlyRobber.body'},
                image: LobbyImage.Robber,
                visible: true,
            },
            {
                header: {key: 'strings:roomPage.rules.ruleInformation.balancedDice.header'},
                text: {key: 'strings:roomPage.rules.ruleInformation.balancedDice.body'},
                image: LobbyImage.Dice6,
                visible: true,
            },
            {
                header: {key: 'strings:roomPage.rules.ruleInformation.noTrolls.header'},
                text: {key: 'strings:roomPage.rules.ruleInformation.noTrolls.body'},
                image: LobbyImage.IconNoTroll,
                visible: !this.isTournamentRoom,
            },
            {
                header: {key: 'strings:roomPage.orderSelection.title'},
                text: {key: 'strings:roomPage.orderSelection.description'},
                image: LobbyImage.ProfileRanked,
                visible: this.isTournamentRoom,
            },
        ]

        return rulesInformationBodyElements.filter((ruleInformation) => ruleInformation.visible)
    }

    private initializeRulesInformationBody(rulesInformationBody: RuleInformationBodyElement[]) {
        this.contentContainer.classList.add('popup-rules-information')
        if(this.body.firstChild) this.body.removeChild(this.body.firstChild)

        for(const ruleInformation of rulesInformationBody) {
            const ruleContainer = createDivIn(this.body, 'rule-container')
            const imageContainer = createDivIn(ruleContainer, 'rule-image-container')
            createImgIn(imageContainer, ruleInformation.image, 'rule-image')
            const textContainer = createDivIn(ruleContainer, 'rule-text-container')
            createHeaderIn(textContainer, ruleInformation.header, 'rule-header')
            createParagraphIn(textContainer, ruleInformation.text, 'rule-text')
        }
    }
}
